import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

declare var BoldBI: any;

@Component({
  selector: 'app-dynamic-dashboard',
  templateUrl: './dynamic-dashboard.component.html',
  styleUrls: ['./dynamic-dashboard.component.scss'],

})

export class DynamicDashboardComponent implements OnInit, OnDestroy {
  currentTab = 'overview';
  dashboardIds = {
    'overview': '0bb0f333-a88c-4eab-89c5-90bfe7d0adab',
    'invoiceables': 'f3ba7131-66dd-4a0a-befe-03d53f83deaf',
    'study-details': '4542a924-1d4e-4f4c-ac13-ebd374eda9c0',
    'department-analysis': 'fa260768-e63d-41fa-be9e-f8d6dad0da9a',
    'cross-check': 'a60ed274-033b-4085-b301-2091281bf3c8'
  };
  dashboardInstance: any; // Store reference for resizing
  private handleResize: () => void = () => { };

  ngOnInit() {
    document.body.classList.add('dynamic-dashboard-active');
    document.body.style.overflow = 'hidden';
    this.loadDashboard(this.dashboardIds['overview']);
    document.body.style.overflow = 'auto';
    window.removeEventListener('resize', this.handleResize); // Clean up
  }

  ngOnDestroy() {
    document.body.classList.remove('dynamic-dashboard-active');
    document.body.style.overflow = '';
    window.removeEventListener('resize', this.handleResize); // Clean up
  }
  switchTab(tabKey: string): void {
    this.currentTab = tabKey;
    this.loadDashboard(this.dashboardIds[tabKey]);
  }


  public loadDashboard(dashboardId: string): void {

    const apiHost = 'https://us-central1-cyan-cluster.cloudfunctions.net';
    const data = {
      ServerUrl: 'https://bi.dashstack.com/bi',
      SiteIdentifier: 'tufts',
      UserEmail: 'user@gmail.com',
      UserGroup: 'Anonymous',
      ApiKey: '6OutK6uCYYJbLVM93Vk2',
      DashboardId: dashboardId
    };

    // Alternative data for tufts:
    // ServerUrl: 'https://bi.dashstack.com/bi',
    // SiteIdentifier: 'tufts',
    // UserEmail: 'user@gmail.com',
    // UserGroup: 'Anonymous',
    // ApiKey: '6OutK6uCYYJbLVM93Vk2',
    // DashboardId: '1fe9f085-f3e1-4fed-b0d1-46828a6fa961'

    const authUrl = `${apiHost}/get_ext_user_bold_bi_site_authorization_token`
      + `?userEmail=${encodeURIComponent(data.UserEmail)}`
      + `&userGroup=${encodeURIComponent(data.UserGroup)}`
      + `&site=${encodeURIComponent(data.SiteIdentifier)}`
      + `&apiKey=${encodeURIComponent(data.ApiKey)}`;

    let filterQuery = "";
    try {
      const userData = JSON.parse(localStorage.getItem('userData'));
      if (userData && userData.tuftsDepartments && Array.isArray(userData.tuftsDepartments) && userData.tuftsDepartments.length > 0) {
        const depts = userData.tuftsDepartments.map(d => typeof d === 'object' ? d.department : d);
        // depts should be a comma separated list
        const deptString = depts.join(',');
        filterQuery = `therapeuticArea__description=${deptString}&hide_filter=therapeuticArea__description`;
      }
    } catch (e) {
      console.error("Error parsing user data for dashboard filter", e);
    }

    // Clean up previous dashboard if it exists
    if (this.dashboardInstance) {
      this.dashboardInstance.destroy();
    }

    const dashboard = (window as any).BoldBI.create({
      serverUrl: `${data.ServerUrl}/site/${data.SiteIdentifier}`,
      dashboardId: data.DashboardId,
      embedType: (window as any).BoldBI.EmbedType.Component,
      environment: (window as any).BoldBI.Environment.Enterprise,
      embedContainerId: 'dashboard',
      width: '100%',
      height: `${window.innerHeight}px`,
      expirationTime: 100000,
      authorizationServer: { url: authUrl },
      scrolling: 'no',
      filterParameters: filterQuery
    });


    dashboard.loadDashboard();
    this.dashboardInstance = dashboard;
    // Attach resize event
    window.removeEventListener('resize', this.handleResize); // Remove old in case of reload
    this.handleResize = () => {
      dashboard.setSize('100%', `${window.innerHeight}px`);
    };
    window.addEventListener('resize', this.handleResize);
  }
}
